import { Link } from "react-router-dom";
import CheckBox, { CheckBoxType } from "./CheckBox";

const FormFooter = ({ labelText, value, setValue }: CheckBoxType) => {
  return (
    <div className="w-full">
      <div className="flex justify-between w-full">
        {/* Remember me checkbox */}
        <CheckBox labelText={labelText} setValue={setValue} value={value} />
        {/* Forgot password link */}
        <Link
          to="/forgot"
          className="text-violet-500 w-max md:text-base sm:text-sm"
        >
          Forgot password?
        </Link>
      </div>
    </div>
  );
};

export default FormFooter;
